import { getIn } from "formik";

export default function getRelianceIPAOptionLabelHelper(option, formik, name) {
  let optionLabel = "";

  if (option?.pin_code !== undefined) {
    optionLabel = `${option?.pin_code}, ${option?.area_name}, ${option?.district_name}, ${option?.state_name}`;
  } else if (option === "") {
    optionLabel = "";
    // console.log("optionLabel: ", optionLabel);
  } else {
    let addressFields = [];
    if (name === "proposerDetails.CommunicationAddress.Pincode") {
      addressFields = [
        "proposerDetails.CommunicationAddress.Area",
        "proposerDetails.CommunicationAddress.District",
        "proposerDetails.CommunicationAddress.State",
      ];
    } else if (name === "proposerDetails.PermanentAddress.Pincode") {
      addressFields = [
        "proposerDetails.PermanentAddress.Area",
        "proposerDetails.PermanentAddress.District",
        "proposerDetails.PermanentAddress.State",
      ];
    } else if (name === "nomineeDetails.NomineeAddress.Pincode") {
      addressFields = [
        "nomineeDetails.NomineeAddress.Area",
        "nomineeDetails.NomineeAddress.District",
        "nomineeDetails.NomineeAddress.State",
      ];
    }
    const fieldValues = addressFields.map((field) =>
      getIn(formik.values, field)
    );
    optionLabel = [option, ...fieldValues].filter(Boolean).join(", ");
  }

  // console.log("optionLabel: ", name, optionLabel);
  return optionLabel;
}
